export var isPurchaseQuoteRoute = function (path) {
    return /^\/purchase-assist\/quote(?:\/[^/]+)?\/?$/i.test(path);
};
